exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avartarUpload[data-v-44fc689e]{border-radius: 50%;width:1.33333rem;height:1.33333rem;}\n\n", ""]);

// exports
